// @ts-nocheck
import * as React from "react";

const PersonAddLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m10 13 .24.004A7 7 0 0 1 17 20l-.007.117A1 1 0 0 1 15 20l-.005-.217A5 5 0 0 0 5 20l-.007.117A1 1 0 0 1 3 20l.004-.24A7 7 0 0 1 10 13Zm0-10a4 4 0 1 1 0 8l-.2-.005A4 4 0 0 1 6 7l.005-.2A4 4 0 0 1 10 3Zm9 1a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V8h-1a1 1 0 1 1 0-2h1V5a1 1 0 0 1 1-1Zm-9 1-.15.005A2 2 0 0 0 8 7l.005.15A2 2 0 1 0 10 5Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(PersonAddLine);
